
import { DnTextarea } from '@digitalnatives/form-input';

export default {
    extends: DnTextarea
};
